import { useCallback, useLayoutEffect, useRef } from "react";

import type { RefObject } from "react";

const useHideAfterClose = (
  open: boolean,
  overrideRef?: RefObject<HTMLDivElement>,
  disabled: boolean = false
) => {
  const ref = useRef<HTMLDivElement>(null);

  const onAnimationStart = useCallback(() => {
    const refToUse = overrideRef || ref;
    if (!refToUse.current || disabled) {
      return;
    }

    if (open) {
      refToUse.current.style.removeProperty("display");
    }
  }, [disabled, open, overrideRef]);

  const onAnimationEnd = useCallback(() => {
    const refToUse = overrideRef || ref;
    if (!refToUse.current || disabled) {
      return;
    }

    if (!open) {
      refToUse.current.style.display = "none";
    }
  }, [disabled, open, overrideRef]);

  useLayoutEffect(() => {
    const refToUse = overrideRef || ref;
    if (!open && refToUse.current && !disabled) {
      refToUse.current.style.display = "none";
    }
  }, [overrideRef]); // eslint-disable-line react-hooks/exhaustive-deps

  return { ref, onAnimationStart, onAnimationEnd };
};

export default useHideAfterClose;
